import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { getPostsAction } from "../actions/postActions";
import { getOverallStatisticsAction } from "../actions/orderActions";
import { updateCartItemQuantity, setCartOpen } from "../actions/cartActions";
import PostCard from "../components/PostCard";
import MissingPostCard from "../components/MissingPostCard";
import FoundPostCard from "../components/FoundPostCard";
import Filter from "../components/Filter";
import Banner from "../components/Banner";
import CustomQr from "../components/CustomQr";
import QrTagSlider from "../components/QrTagSlider";
import GpsTrackerSlider from "../components/GpsTrackerSlider";
import PethubGallery from "../components/PethubGallery";
import ProblemSolutionSteps from "../components/ProblemSolutionSteps";
import PinOnMap from "../components/PinOnMap";
import CommunitySection from "../components/PethubCommunity";

import RightContianer from "../components/RightContainer";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Grid,
  Navigation,
  Pagination,
  Autoplay,
  Scrollbar,
  A11y,
  Mousewheel,
} from "swiper/modules";
import { ShoppingCart, Smile } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faMapMarkerAlt,
  faBatteryFull,
  faGlobeAmericas,
  faTint,
  faQrcode,
  faAddressCard,
} from "@fortawesome/free-solid-svg-icons";

const Home = ({
  getPostsAction,
  posts,
  stickyBanner,
  overallStatistics,
  getOverallStatisticsAction,
  updateCartItemQuantity, // დაამატეთ ეს
  setCartOpen, // დაამატეთ ეს
  darkMode,
}) => {
  const VIPSwiperRef = useRef(null);
  const missingSwiperRef = useRef(null);
  const foundSwiperRef = useRef(null);
  const qrTagSwiperRef = useRef(null);
  useEffect(() => {
    getPostsAction();
    getOverallStatisticsAction();
  }, []);

  const renderMainFilter = (post_type) => {
    if (posts[post_type] !== null) {
      return <Filter />;
    }
    return null;
  };
  console.log(overallStatistics);
  const renderPosts = (post_type) => {
    if (posts[post_type] !== null) {
      return posts[post_type].map((item, i) => {
        if (post_type === "missing_posts") {
          return (
            <SwiperSlide>
              <MissingPostCard data={item} key={i} />
            </SwiperSlide>
          );
        } else if (post_type === "found_posts") {
          return (
            <SwiperSlide>
              <FoundPostCard data={item} key={i} />
            </SwiperSlide>
          );
        } else if ("vip_posts") {
          return (
            <SwiperSlide>
              <PostCard data={item} key={i} />
            </SwiperSlide>
          );
        } else {
          return <PostCard data={item} key={i} />;
        }
      });
    }
  };

  const handlePrev = (swiperRef) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = (swiperRef) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handleAddToCart = (color) => {
    // ამატებს 1 ერთეულს მითითებულ ფერს qr-collar კატეგორიაში
    updateCartItemQuantity("qr-collar", color, 1);
    // ხსნის გლობალურ კალათას
    // setCartOpen(true);
  };

  const handleAddGPSToCart = (color) => {
    // აქ ვიყენებთ "gps-tracker" იდენტიფიკატორს
    updateCartItemQuantity("gps-tracker", color, 1);
    // ვხსნით კალათას
    setCartOpen(true);
  };

  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(1);

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      {/* <div className="shape-bg shape-1"></div> */}
      {/* <div className="shape-bg shape-2"></div> */}

      {/* Hero Section */}
      <div className="qr-tags-container qr-tags-container-2">
        <div className="qr-tags-container-overlay">
          <div className="text-for-qr-tags-container">
            {!isMobile ? (
              <div className="qr-tag-main-text">
                <p className="main-text">
                  <p className="hero-title-1">{t("hero title 1")}</p>
                  <p className="hero-title-2"> {t("hero title 2")}!</p>
                </p>
                <p className="pethub_app_text">{t("hero description")}</p>
                <div className="home-banner-order-button">
                  <Link to="/order/qrcollar">
                    {t("select your tag")}
                    <FontAwesomeIcon icon={faArrowRight} size="1x" />
                  </Link>
                </div>
                <div className="trust-badges">
                  <div className="badge">
                    <FontAwesomeIcon
                      icon={faQrcode}
                      // size="sm"
                      className="fa-users-icon"
                    />
                    <span>{t("quick scan")}</span>
                  </div>
                  <div className="badge">
                    <FontAwesomeIcon
                      icon={faMapMarkerAlt}
                      // size="sm"
                      className="fa-checkcircle-icon"
                    />
                    <span>{t("gps notification")}</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="qr-tag-main-text">
                <p className="main-text">
                  <p className="hero-title-1">
                    {t("hero title 1")}{" "}
                    <span style={{ color: "#414141" }}>
                      {t("hero title 2")}!
                    </span>
                  </p>
                </p>
                <p className="pethub_app_text">{t("hero description")}</p>
                <div className="trust-badges">
                  <div className="badge">
                    <FontAwesomeIcon
                      icon={faQrcode}
                      // size="sm"
                      className="fa-users-icon"
                    />
                    <span>{t("quick scan")}</span>
                  </div>
                  {/* <div className="badge">
                    <FontAwesomeIcon
                      icon={faAddressCard}
                      // size="sm"
                      className="fa-rotate-icon"
                    />
                    <span>{t("owner profile")}</span>
                  </div> */}
                  <div className="badge">
                    <FontAwesomeIcon
                      icon={faMapMarkerAlt}
                      // size="sm"
                      className="fa-checkcircle-icon"
                    />
                    <span>{t("gps notification")}</span>
                  </div>
                </div>
                <div className="home-banner-order-button">
                  <Link to="/order/qrcollar">
                    {t("select your tag")}
                    <FontAwesomeIcon icon={faArrowRight} size="1x" />
                  </Link>
                </div>
              </div>
            )}

            <div className="home-page-image-in-right-container">
              <img
                className="right-face-img"
                src={darkMode ? "img/pet-dark.png" : "img/pet.webp"}
                alt="Pet"
              />
              {/* Floating Icons */}
              {/* <div className="floating-icon shield-icon">
                      <i className="fas fa-shield-alt"></i>
                      <FontAwesomeIcon
                        icon={faShieldAlt}
                        size="sm"
                        className="fa-shield-alt-icon"
                      />
                    </div>
                    <div className="floating-icon heart-icon">
                      <FontAwesomeIcon
                        icon={faMapMarkerAlt}
                        size="sm"
                        className="fa-map-marker-alt-icon"
                      />
                    </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="parent-container-short">
        <div className="members-and-tags-counter-container">
          {/* <div className="">
                                                                                                                                                                                                                                                                                                                                                  <span>{t("users")}</span>
                                                                                                                                                                                                                                                                                                                                                  <span>21187</span>
                                                                                                                                                                                                                                                                                                                                                </div> */}
          <div className="">
            <span> {t("members")} </span>
            <span> {overallStatistics.total_members} </span>
          </div>
          <div className="">
            <span> {t("active qr tags")} </span>
            <span> {overallStatistics.active_tag} </span>
          </div>
          {/* <div className="">
                                                                                                                                                                                                                                                                                                                                                  <span>{t("active gps tracker")}</span>
                                                                                                                                                                                                                                                                                                                                                  <span>471</span>
                                                                                                                                                                                                                                                                                                                                                </div> */}
          <div className="">
            <span> {t("lost pets")} </span>
            <span> {overallStatistics.lost} </span>
          </div>
          <div className="">
            <span> {t("found pets")} </span>
            <span> {overallStatistics.found} </span>
          </div>
        </div>
      </div>
      <QrTagSlider t={t} handleAddToCart={handleAddToCart} />

      <GpsTrackerSlider t={t} handleAddGPSToCart={handleAddGPSToCart} />

      <div className="parent-container-short">
        <ProblemSolutionSteps />
        <PinOnMap />
      </div>
      <CommunitySection />

      <div className="parent-container-short">
        <div className="pethub-qr-tag-features-parent-container">
          <h2 className="containers-headline-text">{t("why pethub?")}</h2>

          <div className="pethub-qr-tag-features-inside-container">
            {/* Card 1 */}
            <div className="pethub-qr-tag-features-card">
              <img
                className="pethub-qr-tag-features-img"
                src="/img/UpdatePetProfile.webp"
              />
              <div className="pethub-qr-tag-features-description">
                <p>{t("update information")}</p>
                <p>{t("update-info-description-1")}</p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="pethub-qr-tag-features-card">
              <img
                className="pethub-qr-tag-features-img"
                src="/img/GPSNotification.webp"
              />
              <div className="pethub-qr-tag-features-description">
                <p>{t("gps notification")}</p>
                <p>{t("gps collar description for main page")}</p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="pethub-qr-tag-features-card">
              <img
                className="pethub-qr-tag-features-img"
                src="/img/ProfileOpenLock.webp"
              />
              <div className="pethub-qr-tag-features-description">
                <p>{t("protected system")}</p>
                <p>{t("privacy control description for main page")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tag-functionality-parent-container">
        {/* <div className="tag-functionality-badge">
            <FontAwesomeIcon icon={faCogs} size="sm" className="fa-star-icon" />
            {t("tag features")}
          </div> */}
        <p className="tag-functionality-title">
          <span className="highlight-text">{t("pethub tag features")}</span>
          <br />
          {t("pethub tag features description for main page")}
        </p>
        <div className="tag-functionality-container">
          {/* <!-- Card 1: No Battery --> */}
          <div className="feature-card card-1">
            <div className="dots">
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <div className="icon-box icon-box-1">
              <FontAwesomeIcon
                icon={faBatteryFull}
                size="sm"
                className="fa-battery-full-icon"
              />
            </div>
            <div className="card-content">
              <h3>{t("no batteries needed")}</h3>
              <p>{t("no batteries needed description for main page")}</p>
            </div>
          </div>

          {/* <!-- Card 2: Durability --> */}
          <div className="feature-card card-2">
            <div className="dots">
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <div className="icon-box icon-box-2">
              <FontAwesomeIcon
                icon={faTint}
                size="sm"
                className="fa-tint-icon"
              />
            </div>
            <div className="card-content">
              <h3>{t("waterproof")}</h3>
              <p>{t("scratch, bite, and fade resistant-2")}</p>
            </div>
          </div>

          {/* <!-- Card 3: Global Coverage --> */}
          <div className="feature-card card-3">
            <div className="dots">
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <div className="icon-box icon-box-3">
              <FontAwesomeIcon
                icon={faGlobeAmericas}
                size="sm"
                className="fa-globe-americas-icon"
              />
            </div>
            <div className="card-content">
              <h3>{t("works anywhere and anytime")}</h3>
              <p>{t("gps-collar-description-3")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="parent-container-short">
        <CustomQr />
      </div>

      {/* <div className="our-inspiration-parent-container">
        <div className="our-inspiration-description-container">
          <Smile className="our-inspiration-icon" />

          <h4 className="highlight-text">{t("our inspiration")}</h4>

          <span className="our-inspiration-description">
            {t("our inspiration description for main page")}
          </span>
        </div>
        <div className="our-inspiration-img-container">
          <img src="/img/1-7.webp" alt="" />
        </div>
      </div> */}

      {/* <PethubGallery /> */}
      <div className="parent-container-short">
        {/* <Filter />  */}
        {/* {renderMainFilter()} */}
        {/* <div className="main-container">
            <div className="left-container">
              <div className="vip-post-container">
                <div className="vip-post-container-header">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                      <path d="M18 29h-4c-1.1 0-2-.9-2-2V15H8.4c-.8 0-1.5-.5-1.8-1.2s-.2-1.6.4-2.2l8.3-8.3c.4-.4 1-.4 1.4 0l8.3 8.3c.6.6.7 1.4.4 2.2s-1 1.2-1.8 1.2H20v12c0 1.1-.9 2-2 2z" />
                    </svg>
                  </span>
                  <p> VIP </p>
                  <div className="next-prev">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="prev"
                      onClick={() => handlePrev(VIPSwiperRef)}
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM15.5 12h-6">
                          
                        </path>
                        <path d="M11.5 9l-3 3 3 3"> </path>
                      </g>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="next"
                      onClick={() => handleNext(VIPSwiperRef)}
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM8.5 12h6">
                          
                        </path>
                        <path d="M12.5 15l3-3-3-3"> </path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="vip-inside-cards-container">
                  <Swiper
                    ref={VIPSwiperRef}
                    wrapperClass="cards-swiper-container"
                    spaceBetween={15}
                    breakpoints={{
                      0: {
                        slidesPerView: 1.2,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                      1023: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                      1281: {
                        slidesPerView: 5,
                      },
                      1601: {
                        slidesPerView: 5,
                      },
                    }}
                  >
                    {renderPosts("vip_posts")}
                  </Swiper>
                </div>
              </div>
              <Banner />
              <div className="missing-post-main-container">
                <div className="left-container-posts-header">
                  <span className="dep-lost">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="department-icon"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M22 8v4M10.25 5.5H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.31C2 7.78 2 8.62 2 10.3v1.2c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083c.367.152.833.152 1.765.152v4.25c0 .232 0 .348.01.446a2 2 0 0 0 1.794 1.794c.098.01.214.01.446.01s.348 0 .446-.01a2 2 0 0 0 1.794-1.794c.01-.098.01-.214.01-.446V14.5h.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.946.946 0 0 0 .691-.411c.187-.26.187-.783.187-1.827V5.126c0-1.044 0-1.566-.187-1.827a.946.946 0 0 0-.691-.411c-.319-.039-.805.226-1.778.756-1.667.909-3.828 1.856-5.594 1.856Z"
                      />
                    </svg>
                  </span>
                  <p> {t("missing")} </p>
                  <div className="next-prev">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="prev"
                      onClick={() => handlePrev(missingSwiperRef)}
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM15.5 12h-6">
                          
                        </path>
                        <path d="M11.5 9l-3 3 3 3"> </path>
                      </g>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="next"
                      onClick={() => handleNext(missingSwiperRef)}
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM8.5 12h6">
                          
                        </path>
                        <path d="M12.5 15l3-3-3-3"> </path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="missing-card-container">
                  <Swiper
                    ref={missingSwiperRef}
                    wrapperClass="cards-swiper-container"
                    spaceBetween={15}
                    breakpoints={{
                      0: {
                        slidesPerView: 1.2,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                      1023: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                      1281: {
                        slidesPerView: 5,
                      },
                      1601: {
                        slidesPerView: 5,
                      },
                    }}
                  >
                    {renderPosts("missing_posts")}
                  </Swiper>
                </div>
              </div>
              <div className="founded-post-main-container">
                <div className="left-container-posts-header">
                  <span className="dep-found">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="department-icon"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M22 8v4M10.25 5.5H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.31C2 7.78 2 8.62 2 10.3v1.2c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083c.367.152.833.152 1.765.152v4.25c0 .232 0 .348.01.446a2 2 0 0 0 1.794 1.794c.098.01.214.01.446.01s.348 0 .446-.01a2 2 0 0 0 1.794-1.794c.01-.098.01-.214.01-.446V14.5h.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.946.946 0 0 0 .691-.411c.187-.26.187-.783.187-1.827V5.126c0-1.044 0-1.566-.187-1.827a.946.946 0 0 0-.691-.411c-.319-.039-.805.226-1.778.756-1.667.909-3.828 1.856-5.594 1.856Z"
                      />
                    </svg>
                  </span>
                  <p> {t("found")} </p>
                  <div className="next-prev">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="prev"
                      onClick={() => handlePrev(foundSwiperRef)}
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM15.5 12h-6">
                          
                        </path>
                        <path d="M11.5 9l-3 3 3 3"> </path>
                      </g>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="next"
                      onClick={() => handleNext(foundSwiperRef)}
                      viewBox="0 0 24 24"
                    >
                      <g
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM8.5 12h6">
                          
                        </path>
                        <path d="M12.5 15l3-3-3-3"> </path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="founded-card-container">
                  <Swiper
                    ref={foundSwiperRef}
                    wrapperClass="cards-swiper-container"
                    spaceBetween={15}
                    breakpoints={{
                      0: {
                        slidesPerView: 1.2,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                      1023: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                      1281: {
                        slidesPerView: 5,
                      },
                      1601: {
                        slidesPerView: 5,
                      },
                    }}
                  >
                    {renderPosts("found_posts")}
                  </Swiper>
                </div>
              </div>
              {stickyBanner ? (
                <div className="sticky-banner-container2">
                  <a href={stickyBanner.url} target="_blank">
                    <img src={stickyBanner.banner_img} alt="sticky-banner" />
                  </a>
                </div>
              ) : (
                <> </>
              )}
              <div className="recently-added-container">
                <div className="left-container-posts-header">
                  <p> {t("recently added")} </p>
                </div>
                <div className="recently-added-inside-container">
                  <Swiper
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                      1023: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                      1281: {
                        slidesPerView: 5,
                      },
                      1601: {
                        slidesPerView: 5,
                      },
                    }}
                    grid={{
                      rows: 7,
                      fill: "row",
                    }}
                    spaceBetween={15}
                    modules={[Grid]}
                    className="mySwiper"
                  >
                    {renderPosts("latest_posts")}
                  </Swiper>
                </div>
              </div>
            </div>
            <RightContianer />
          </div> */}
      </div>
      {/* <!--END MAIN CONTAINER--> */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    posts: state.posts,
    stickyBanner: state.management.stickyBanner,
    overallStatistics: state.orders.overallStatistics,
  };
};
export default connect(mapStateToProps, {
  getPostsAction,
  getOverallStatisticsAction,
  updateCartItemQuantity, // დაამატეთ ეს
  setCartOpen, // დაამატეთ ეს
})(Home);
